import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { CS_FONT, CS_WEIGHT, csTokens } from 'components/CallScribe/callScribeTheme';

const useAddPersonOverlayStyles = makeStyles((theme: Theme) => {
  const t = csTokens(theme);
  return {
    top: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      padding: '4px 16px 0',
    },
    keypadToggle: {
      flex: '0 0 auto',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      minHeight: 44,
      margin: '-6px -4px -8px 0',
      padding: '0 10px',
      border: 'none',
      borderRadius: 10,
      background: 'transparent',
      color: t.text2,
      fontFamily: 'inherit',
      ...CS_FONT.small,
      fontWeight: CS_WEIGHT.strong,
      cursor: 'pointer',
      transition: 'background-color 150ms ease-out',
      '& svg': { fontSize: 18 },
      '&:hover': { background: t.surface3, color: t.text },
      '&[aria-expanded="true"]': { color: t.text },
      '&:focus-visible': { outline: `2px solid ${t.focus}`, outlineOffset: 2 },
    },
    keypadWrap: {
      display: 'grid',
      gridTemplateRows: '1fr',
      opacity: 1,
      transition: 'grid-template-rows 200ms ease-out, opacity 200ms ease-out, visibility 0s linear 0s',
      '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
    },
    keypadCollapsed: {
      gridTemplateRows: '0fr',
      opacity: 0,
      visibility: 'hidden',
      transition: 'grid-template-rows 200ms ease-out, opacity 200ms ease-out, visibility 0s linear 200ms',
      '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
    },
    keypadInner: {
      minHeight: 0,
      overflow: 'hidden',
    },
    listArea: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      padding: '4px 12px 16px',
      flex: '1 0 auto',
    },
    notice: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 8,
      margin: '8px 4px 0',
      padding: '8px 12px',
      borderRadius: 10,
      background: t.warnBg,
      color: t.warn,
      ...CS_FONT.small,
      fontWeight: CS_WEIGHT.strong,
      '& span': { ...CS_FONT.small, fontWeight: CS_WEIGHT.strong },
    },
    noticeAction: {
      border: 'none',
      background: 'transparent',
      padding: '0 8px',
      minHeight: 44,
      fontFamily: 'inherit',
      ...CS_FONT.small,
      fontWeight: CS_WEIGHT.heavy,
      color: t.warn,
      textDecoration: 'underline',
      cursor: 'pointer',
      '&:focus-visible': { outline: `2px solid ${t.focus}`, outlineOffset: 2, borderRadius: 4 },
    },
    empty: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: 8,
      padding: '28px 24px',
    },
    emptyRing: {
      width: 56,
      height: 56,
      borderRadius: '50%',
      display: 'grid',
      placeItems: 'center',
      background: t.surface3,
      color: t.text2,
      '& svg': { fontSize: 26 },
    },
    emptyTitle: {
      margin: 0,
      fontSize: 16,
      lineHeight: '22px',
      fontWeight: CS_WEIGHT.heavy,
      color: t.text,
    },
    emptyBody: {
      margin: 0,
      ...CS_FONT.small,
      color: t.text2,
      maxWidth: '36ch',
    },
    skeletonGroup: {
      fontSize: 11,
      lineHeight: '14px',
      fontWeight: CS_WEIGHT.heavy,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: t.text3,
      padding: '12px 4px 6px',
    },
    skeleton: {
      height: 56,
      margin: '2px 0',
      borderRadius: 12,
      background: t.surface3,
      animation: '$pulse 1200ms ease-in-out infinite',
      '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
    },
    '@keyframes pulse': {
      '0%': { opacity: 1 },
      '50%': { opacity: 0.55 },
      '100%': { opacity: 1 },
    },
    alert: {
      margin: 0,
      ...CS_FONT.small,
      fontWeight: CS_WEIGHT.strong,
      color: t.neg,
      overflowWrap: 'anywhere',
    },
  };
});

export default useAddPersonOverlayStyles;
